import { v4 as uuidv4 } from "uuid";

export const emptyWorkExperience = {
  id: uuidv4(),
  employerName: "",
  position: "",
  startDate: "",
  endDate: "",
  responsibilities: "",
  employmentReasonForLeaving: "",
};

export const emptyLanguage = {
  id: uuidv4(),
  language: "",
  level: "",
};


   export const initialFormData = {
    fullName: "",
    firstName: "",
    lastName: "",
    email: "",
    telefon: "",
    pozicioni:'',
    datePersonal: "",
    nationality: "",
    gjinia: "",
    adresaPersonal: "",
    mundësiaPunë: "",
    startDateAvailable: "",
    salaryRangeExpectationMinimum: "",
    salaryRangeExpectationMaximum: "",
    educationHighestLevel: "",
    educationInstitutionName: "",
    educationFieldOfStudy: "",
    educationGraduationYearEnd: "",
    educationAdditionalCertifications: "",
    relativesWorking: "",
    securityBackgroundChecks: "",
    physicalFitRequirement: "",
    drivingLicense: "",
    airportSystemsExperience: "",
    institution: "",
    location: "",
    name: "",
    diploma: "",
    startDate: "",
    endDate: "",
    workExperience: [emptyWorkExperience],
    computerPrograms: {},
    computerSkillsData: {
      msOfficeSkills: false,
      sapErpSkills: false,
      customerServiceSkills: false,
      teamWorkSkills: false,
      communicationSkills: false,
      problemSolvingSkills: false,
      leadershipSkills: false,
      otherComputerSkills: false,
      otherComputerSkillsDetail: "",
      hasDrivingLicense: false,
      drivingLicenseType: "",
      airportSystemsExperience: "",
    },
    foreignLanguages: [emptyLanguage],
    relativesWorkingNameSpecifications: "",
    relativesWorkingRelationshipSpecifications: "",
    jobApplicationNotice: "",
    reasonForApplying: "",
    coverLetterFile: null,
    cvFile: null,
    photoFile: null,
    dataProtectionAgreement: false,
    verificationAuthorization: false,
    signatureDigital: "",
    dateOfDeclaration: "",
  };